









import {
  Vue,
  Component,
  Prop,
} from "@/shared/vuepack";
import _ from "lodash";
import { formatCurrency } from "@/shared/currency";
import { DrivewealthAccountSummary, PieChartDataItem } from "@/shared/types";
import { GChart } from "vue-google-charts";
import { useThemeStore } from "@/shared/store/theme";
import { useDrivewealthStore } from "@/shared/store/drivewealth";

@Component({
  components: {
    GChart
  }
})
export default class InvestmentInstrumentPieChart extends Vue {
  @Prop({ default: 220 })
  height: number;

  @Prop({ required: false })
  username: string;

  @Prop({ required: false })
  partnerId: number;

  @Prop({ required: true })
  accountId: number;

  themeStore = useThemeStore();
  drivewealthStore = useDrivewealthStore();

  get chartDataItems (): PieChartDataItem[] {
    return this.accountSummary.holdings.map(x => {
      return {
        value: x.marketValue,
        label: x.stockSymbol
      };
    });
  }

  get getChartOptions () {
    return {
      colors: this.colorsToDisplay.map(x => x.chartColor),
      legend: {
        position: "bottom",
        alignment: "center"
      },
      chartArea: {
        top: 8,
        left: 0,
        width: "95%",
        height: "80%",
      },
      pieHole: 0.5,
      pieSliceText: "Label",
      enableInteractivity: true,
      height: this.height,
      fontSize: 12,
      tooltip: {
        isHtml: true,
      },
    };
  }

  get orderedColors () {
    return [
      {
        chartColor: this.themeStore.primaryColor,
        className: "primary"
      },
      {
        chartColor: this.themeStore.secondaryColor,
        className: "secondary"
      },
      {
        chartColor: this.themeStore.tertiaryColor,
        className: "tertiary"
      },
      {
        chartColor: this.themeStore.primaryColorShifts.lighter,
        className: "primary-lighter"
      },
      {
        chartColor: this.themeStore.secondaryColorShifts.lighter,
        className: "secondary-lighter"
      },
      {
        chartColor: this.themeStore.tertiaryColorShifts.lighter,
        className: "tertiary-lighter"
      },
      {
        chartColor: this.themeStore.primaryColorShifts.darker,
        className: "primary-darker"
      },
      {
        chartColor: this.themeStore.secondaryColorShifts.darker,
        className: "secondary-darker"
      },
      {
        chartColor: this.themeStore.tertiaryColorShifts.darker,
        className: "tertiary-darker"
      }
    ];
  }

  get accountSummary (): DrivewealthAccountSummary {
    return this.drivewealthStore.accountSummaryById(this.accountId);
  }

  get isLoaded (): boolean {
    return this.drivewealthStore.accountSummaryV2Loaded(this.accountId);
  }

  get colorsToDisplay () {
    const colorsArrayLength = this.orderedColors.length;
    const colors = this.chartDataItems.map((item, index) => {
      const indexToDisplay = index % colorsArrayLength;

      return {
        ...item,
        ...this.orderedColors[indexToDisplay]
      };
    });

    return colors;
  }

  get chartData () {
    const items: any[] = [[
      "Label", "Value",
      { role: "tooltip", type: "string", p: { html: true } },
    ]];

    for (const color of this.colorsToDisplay) {
      const tooltipMarkup = this.tooltipFormatter(color.label, color.value);
      items.push([color.label, color.value, tooltipMarkup]);
    }

    return items;
  }

  tooltipFormatter (label: string, value: number): string {
    const markup = `<div margin-bottom: 3px;">
                          ${label}:
                        </div>
                        <div style="color: ${this.themeStore.tertiaryColor}; font-weight: bold;">
                          ${formatCurrency(value)}
                        </div>`;

    return `<div style="padding: 2px 10px; min-width: 120px;">
              ${markup}
            </div>`;
  }
}
